import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customInputs", "latencyGroup"]
  static values = { autoClose: Boolean }

  declare readonly customInputsTargets: HTMLDivElement[]
  declare readonly hasLatencyGroupTarget: boolean
  declare readonly autoCloseValue: boolean

  connect() {
    if (this.autoCloseValue) {
      window.setTimeout(() => this.closeFrame(), 900)
    }

    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
  }

  activationChanged() {
    // Future: hide inherit banner inline. For v1 a save + reload is enough.
  }

  latencyModeChanged(event: Event) {
    const target = event.target as HTMLInputElement
    const custom = target.value === "custom"
    this.customInputsTargets.forEach(el => {
      el.classList.toggle("hidden", !custom)
    })
  }

  close(event?: Event) {
    event?.preventDefault()
    this.closeFrame()
  }

  private onKeydown = (event: KeyboardEvent) => {
    if (event.key === "Escape") this.closeFrame()
  }

  private closeFrame() {
    const frame = document.getElementById("api_key_replay_frame") as HTMLElement | null
    if (!frame) return
    // Empty the frame to dismiss the dialog.
    frame.innerHTML = '<turbo-frame id="api_key_replay_frame"></turbo-frame>'
  }
}
